/* istanbul ignore file: under testing */
import { SliderGalleryStore } from './sliderGalleryStore';
import { getStyleParamsWithDefaults } from '@wix/wixstores-client-common-components/dist/src/outOfIframes/defaultStyleParams/getStyleParamsWithDefaults';
import { ProductsService } from '../services/productsService';
import { getStyleParamsWithDefaultsFunc } from '../getStyleParamsWithDefaultsFunc';
import { withPropsSerialization } from '@wix/native-components-infra/dist/src/utils/propsSerializer';
export function sliderGalleryController(controllerFactoryConfig) {
    var galleryStore;
    var compId = controllerFactoryConfig.compId, config = controllerFactoryConfig.config, setProps = controllerFactoryConfig.setProps, factoryContext = controllerFactoryConfig.context, type = controllerFactoryConfig.type, reportError = controllerFactoryConfig.reportError, warmupData = controllerFactoryConfig.warmupData;
    var styleParams = config.style.styleParams;
    return {
        pageReady: function () {
            var styleParamsWithDefaults = getStyleParamsWithDefaults(styleParams, function () {
                return getStyleParamsWithDefaultsFunc({ style: { styleParams: styleParams }, dimensions: undefined });
            });
            var MAX_PRODUCTS_PER_PAGE_WHEN_DEFAULT_SETTINGS = 24;
            var initialProductsCount = styleParamsWithDefaults.numbers.galleryColumns * styleParamsWithDefaults.numbers.galleryRows ||
                MAX_PRODUCTS_PER_PAGE_WHEN_DEFAULT_SETTINGS;
            var productsService = new ProductsService(factoryContext.siteStore, initialProductsCount, warmupData, 'Slider Gallery');
            galleryStore = new SliderGalleryStore(styleParamsWithDefaults, config, withPropsSerialization(setProps), factoryContext.siteStore, productsService, compId, reportError, type, warmupData);
            return galleryStore.setInitialState();
        },
        updateConfig: function (_$w, _a) {
            var newStyleParams = _a.style.styleParams, newPublicData = _a.publicData;
            galleryStore.updateState(newStyleParams, newPublicData);
        },
    };
}
//# sourceMappingURL=sliderGalleryController.js.map